__webpack_require__.p = "/assets/turbo/90cc6264/lascanach/_next/";